(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      // Suppress the settle animation for state set during load (e.g. the
      // browser restoring a mid-page scroll position) - only user scrolling
      // after that should animate.
      this.settleReadyAt = performance.now() + 400;
      this.settleAnimations = [];

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledState(true);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledState(true);
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.setScrolledState(false);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    /* Scroll-state toggle with the settle animation from the approved
       scroll-header prototype ("I was a sari - scroll header.html").
       The header's grid still snaps between its two arrangements; on top of
       that, the logo, the inline menu and the icons are FLIP-animated from
       their old spot to their new one (transform 620ms
       cubic-bezier(.45,.05,.2,1)) and the bar height glides (460ms
       cubic-bezier(.4,0,.2,1)) - the prototype's timings. The logo images
       themselves shrink and cross-fade via CSS transitions (see the section
       stylesheet), so nothing here touches markup or layout. */
    setScrolledState(scrolled) {
      if (this.header.classList.contains('scrolled-past-header') === scrolled) return;

      const headerEl = this.header.querySelector('.header--top-center');
      const animate =
        headerEl &&
        typeof headerEl.animate === 'function' &&
        window.matchMedia('(min-width: 990px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
        performance.now() > this.settleReadyAt;

      let pieces = [];
      let firstRects = [];
      let barFirst = 0;
      let logos = [];
      let logoStates = [];
      if (animate) {
        pieces = ['.desk-logo', '.header__inline-menu', '.header__icons']
          .map((selector) => headerEl.querySelector(selector))
          .filter(Boolean)
          // A transform on .header__inline-menu makes it the containing block
          // for the open mega menu's absolutely-positioned panel (left:0;
          // right:0 then span the MENU's box, not the header's), so the open
          // dropdown collapses to ~menu width for the length of the glide.
          // While a dropdown is open the menu links snap instead of gliding
          // and the panel keeps its full width.
          .filter((el) => !(el.classList.contains('header__inline-menu') && el.querySelector('details[open]')));
        // Measure BEFORE cancelling: rects include any in-flight settle
        // transforms, so an interrupted animation continues from where it
        // visually is instead of jumping.
        firstRects = pieces.map((el) => el.getBoundingClientRect());
        barFirst = headerEl.getBoundingClientRect().height;
        // Record the logo images' current visual state (possibly mid-tween)
        // so their CSS transitions can be re-armed from it further down.
        logos = ['.main-logo', '.scroll-logo']
          .map((selector) => headerEl.querySelector(selector))
          .filter(Boolean);
        logoStates = logos.map((el) => {
          const style = getComputedStyle(el);
          return { width: style.width, height: style.height, opacity: style.opacity };
        });
        this.settleAnimations.forEach((animation) => animation.cancel());
        this.settleAnimations = [];
      }

      this.header.classList.toggle('scrolled-past-header', scrolled);
      document.body.classList.toggle('scroll-header', scrolled);

      if (!animate) return;

      // The bar-height glide must end at the header's TRUE resting height.
      // Right after the class toggle the logo images are still at their
      // previous size (their 480ms transition has not advanced), and in the
      // expanded grid the logo row is as tall as the logo itself - measuring
      // now would understate the target by the logo's growth and the bar
      // would visibly snap the difference when the animation ends.
      // So: suppress the logo transitions (one-frame measuring class), read
      // the settled height, then re-arm the tween from the recorded state by
      // pinning inline styles and releasing them with transitions back on.
      // None of this paints - it all happens within this script run.
      headerEl.classList.add('iwas-settle-measure');
      void headerEl.offsetHeight;
      const barResting = headerEl.getBoundingClientRect().height;
      logos.forEach((el, i) => {
        el.style.width = logoStates[i].width;
        el.style.height = logoStates[i].height;
        el.style.opacity = logoStates[i].opacity;
      });
      void headerEl.offsetHeight;
      headerEl.classList.remove('iwas-settle-measure');
      logos.forEach((el) => {
        el.style.width = '';
        el.style.height = '';
        el.style.opacity = '';
      });

      // Bar height glide. min-height would clamp the animation when
      // expanding, so it is lifted for the duration and restored after -
      // only by the animation that is still current, since a cancelled
      // animation's cancel event arrives late.
      if (Math.abs(barFirst - barResting) >= 0.5) {
        headerEl.style.minHeight = '0';
        const barAnimation = headerEl.animate(
          [{ height: `${barFirst}px` }, { height: `${barResting}px` }],
          { duration: 460, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
        );
        this.barAnimation = barAnimation;
        const restore = () => {
          if (this.barAnimation === barAnimation) {
            headerEl.style.minHeight = '';
            this.barAnimation = null;
          }
        };
        barAnimation.onfinish = restore;
        barAnimation.oncancel = restore;
        this.settleAnimations.push(barAnimation);
      }

      // FLIP glide for the pieces. Their "last" rects are measured while the
      // bar-height animation already holds its first frame, so each delta is
      // exactly what the eye should see and the glide starts with no jump.
      pieces.forEach((el, i) => {
        const last = el.getBoundingClientRect();
        const dx = firstRects[i].left - last.left;
        const dy = firstRects[i].top - last.top;
        if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return;
        this.settleAnimations.push(
          el.animate(
            [{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }],
            { duration: 620, easing: 'cubic-bezier(0.45, 0.05, 0.2, 1)' }
          )
        );
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
